import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../fragments/Image";

export const PageProcesses = ({ block }) => {

	const [activeSection, setActiveSection] = useState(block.process[0]?.id);
	const [fadeState, setFadeState] = useState("fade-in"); // 'fade-in' | 'fade-out'

	const handleClick = useCallback((id) => {
		if (id === activeSection) return;
		setFadeState("state-fade-out");
		setTimeout(() => {
			setActiveSection(id);
			setFadeState("state-fade-in");
		}, 800); // match CSS transition duration
	}, [activeSection]);

	if (!block || !block.process) return null;

	return (
		<div className="c-page__block c-page__block--processes c-processes">
			{block.heading &&
                <h3 className="c-page__block__heading" dangerouslySetInnerHTML={{ __html: block.heading }}></h3>
            }
			<div className="l-grid">
				<div className="l-grid__col">
					<nav className="c-processes__nav">
						{block.process.map((section) => (
							<button
								key={section.id}
								className={`c-processes__nav__btn ${activeSection === section.id ? "state-active" : ""}`}
								onClick={() => handleClick(section.id)}
							>
								{section.heading}
							</button>
						))}
					</nav>
				</div>
			</div>

			<div className={`c-processes__content ${fadeState}`}>
				{block.process.map((section) => (
					activeSection === section.id && section.text &&
						<div className="c-processes__section" key={section.id}>
							<div className="l-grid">
								<div className="l-grid__col l-grid__col-m-6-12 l-grid__col--l-4-12">
									<div className="c-processes__section__text scope-text scope-text--faded" dangerouslySetInnerHTML={{ __html: `${section.text}` }}></div>
								</div>
								<div className="l-grid__col l-grid__col-m-6-12 l-grid__col--l-6-12 l-grid__col--l-push-2-12">
									{section.image_src &&
										<div className="c-processes__section__image">
											<Image src={section.image_src} alt={`Image for ${section.heading}`} />
										</div>
									}
								</div>
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default PageProcesses;
